export default "__VITE_ASSET__Od$Cgms0__"